import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
export function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  if (!isVisible) return null;
  return <button onClick={scrollToTop} className="fixed bottom-[25px] right-[25px] bg-alphaGold text-white border-none rounded-full w-12 h-12 flex items-center justify-center cursor-pointer z-[999] transition-colors duration-300 shadow-[0_4px_20px_rgba(212,160,23,0.4)] hover:bg-alphaGoldDark" aria-label="Scroll to top" data-id="element-412">
      <ArrowUp size={24} data-id="element-413" />
    </button>;
}